export default __webpack_public_path__ + "static/media/bergen_3.bd5a889c.jpg";